(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)').matches;

  function kill(el) {
    if (!el || el.classList.contains('product-form__submit')) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.setAttribute('aria-hidden', 'true');
  }

  function hideFriction() {
    var promo = /spin to win|get 10% off|claim discount|email address|sign up/i;
    [
      '[class*="klaviyo"]', '[id*="klaviyo"]', '[data-testid*="klaviyo"]',
      '[class*="kl-teaser"]', '[class*="kl-private"]', '.needsclick', 'iframe[src*="klaviyo"]'
    ].forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          var txt = (el.innerText || el.textContent || '').toLowerCase();
          var rect = el.getBoundingClientRect();
          var isTeaser = String(el.className || '').indexOf('teaser') >= 0;
          var isOverlay = rect.width > 180 && rect.height > 120;
          if (isTeaser || promo.test(txt) || (isOverlay && promo.test(txt))) kill(el);
        });
      } catch (e) {}
    });

    document.querySelectorAll('div, button, a, aside, span, section').forEach(function (el) {
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var low = txt.toLowerCase();
      if (!txt || txt.length > 80) return;
      if (low === 'get 10% off' || low.indexOf('spin to win') === 0 || low === 'spin to win') {
        kill(el);
        if (el.parentElement) kill(el.parentElement);
        if (el.parentElement && el.parentElement.parentElement) kill(el.parentElement.parentElement);
      }
      var st = window.getComputedStyle(el);
      var rect = el.getBoundingClientRect();
      if ((st.position === 'fixed' || st.position === 'absolute') && rect.left < 40 && rect.width < 90) {
        if (promo.test(low) || low.indexOf('off') >= 0) kill(el);
      }
    });
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') >= 0 ||
      !!document.querySelector('.product__info-wrapper .product-form__submit');
  }

  function buildStickyAtc() {
    if (!MOBILE || !isProductPage()) return;
    if (document.querySelector('.pp-mobile-atc-bar')) return;
    var mainBtn = document.querySelector('.product-form__submit, button[name="add"]');
    if (!mainBtn) return;
    var bar = document.createElement('div');
    bar.className = 'pp-mobile-atc-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    var price = document.querySelector('.price__regular .price-item--regular, .price .price-item--regular, .price .price-item');
    var priceEl = document.createElement('span');
    priceEl.className = 'pp-mobile-atc-price';
    priceEl.textContent = price ? price.textContent.trim() : '';
    var btn = mainBtn.cloneNode(true);
    btn.removeAttribute('id');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      mainBtn.click();
    });
    bar.appendChild(priceEl);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    document.body.classList.add('pp-has-mobile-atc');
  }

  hideFriction();
  buildStickyAtc();
  var obs = new MutationObserver(function () {
    hideFriction();
    buildStickyAtc();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  [400, 1200, 3000, 7000].forEach(function (ms) {
    setTimeout(function () { hideFriction(); buildStickyAtc(); }, ms);
  });
})();


/* pp-blog-body-fix-v1 */
(function () {
  var bodies = {
    "10-essential-dog-accessories-every-pet-parent-needs": "<p>Whether you're a first-time dog owner or a seasoned pet parent, the right accessories make every walk, meal, and cuddle easier.</p><h2>Our top 10 essentials</h2><ol><li>Durable leash and collar set</li><li>Rotating squeaky toys</li><li>Grooming kit</li><li>Comfortable bed</li><li>Automatic feeder</li><li>Travel water bottle</li><li>ID tag</li><li>Training treat pouch</li><li>Car seat cover or harness</li><li>Paw cleaning mat</li></ol><p>Explore 91+ premium products at <a href=\"/collections/all?q=dog\">Pets Paradise Global</a>. Use code <strong>PETS10</strong> for 10% off your first order. Buy any 2 items and save 10% automatically.</p>",
    "best-indoor-cat-toys-to-keep-your-cat-active-in-2026": "<p>Indoor cats need stimulation — without it, boredom leads to scratched furniture and restless behaviour.</p><h2>Top indoor cat toy types</h2><ul><li><strong>Automatic rolling balls</strong> — solo play while you're at work</li><li><strong>Cat scratchers</strong> — protect furniture</li><li><strong>Interactive wand toys</strong> — bonding and exercise</li><li><strong>Puzzle feeders</strong> — mental enrichment</li></ul><p>Code <strong>PETS10</strong> for 10% off. <a href=\"/products/electric-cat-ball-toys-automatic-rolling-smart-cat-toys-interactive-for-cats-training-self-moving-kitten-toys-for-indoor-playing\">Shop our automatic cat ball toy →</a></p>",
    "how-to-choose-the-right-pet-bed-for-your-dog-or-cat": "<p>A great pet bed supports better sleep and joint health. Match the bed style to how your pet sleeps — donut beds for curlers, flat mats for sprawlers.</p><h2>Key features</h2><ul><li>Washable covers</li><li>Non-slip bases</li><li>Memory foam for older pets</li></ul><p>Browse <a href=\"/collections/beds\">cosy beds</a> with tracked delivery and our 30-day guarantee. Code <strong>PETS10</strong> saves 10% on your first order.</p>",
    "buy-2-get-10-off-how-our-automatic-discount-works": "<p>Our Buy 2 Get 10% OFF discount applies automatically at checkout — no code required.</p><h2>How it works</h2><ol><li>Add any 2 products to your cart</li><li>Go to checkout</li><li>Your 10% bundle discount is applied automatically</li></ol><p><a href=\"/collections/all\">Start shopping →</a> Code <strong>PETS10</strong> for 10% off your first order.</p>"
  };

  function slugFromPath() {
    var m = window.location.pathname.match(/\/blogs\/[^/]+\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  function textLen(el) {
    return (el && (el.innerText || el.textContent || "").replace(/\s+/g, " ").trim()) || "";
  }

  function inject() {
    var slug = slugFromPath();
    var html = bodies[slug];
    if (!html) return;
    var targets = document.querySelectorAll('[itemprop="articleBody"]');
    if (!targets.length) return;
    var target = targets[0];
    if (textLen(target).length > 80) return;
    target.innerHTML = html;
    target.setAttribute("data-pp-blog-fix", slug);
    var ld = document.querySelector('script[type="application/ld+json"]');
    if (ld) {
      try {
        var data = JSON.parse(ld.textContent);
        if (data && data["@type"] === "Article") {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          data.articleBody = tmp.innerText.replace(/\s+/g, " ").trim();
          ld.textContent = JSON.stringify(data);
        }
      } catch (e) {}
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", inject);
  } else {
    inject();
  }
  [500, 1500, 4000].forEach(function (ms) { setTimeout(inject, ms); });
})();

(function () {
  'use strict';

  /* --- Fix false sold-out badges when product is actually available --- */
  function fixAvailability() {
    var path = window.location.pathname;
    if (path.indexOf('/products/') < 0) return;
    var handle = path.split('/products/')[1].split('?')[0];
    if (!handle) return;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var anyAvail = (p.variants || []).some(function (v) { return v.available; });
        if (!anyAvail) return;
        document.querySelectorAll('.price__badge-sold-out, .badge.price__badge-sold-out').forEach(function (el) {
          el.style.display = 'none';
        });
        document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(function (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('button--disabled');
        });
        document.querySelectorAll('input[type="radio"][name^="options"], select[name="options"]').forEach(function (el) {
          el.disabled = false;
        });
        document.querySelectorAll('.product-form__input--pill label, .variant-option, [data-option-value]').forEach(function (el) {
          var t = (el.innerText || '').toLowerCase();
          if (t.indexOf('sold out') >= 0 || t.indexOf('unavailable') >= 0) {
            el.style.display = 'none';
          }
        });
        document.querySelectorAll('.card__badge, .badge').forEach(function (b) {
          if ((b.innerText || '').trim().toLowerCase() === 'sold out') b.style.display = 'none';
        });
      })
      .catch(function () {});
  }

  /* --- Price deal calculator on PDP --- */
  function injectPriceDeal() {
    if (!/\/products\//.test(location.pathname) || document.querySelector('.pp-price-deal')) return;
    var priceEl = document.querySelector('.price__regular .price-item--regular, .price .price-item--last');
    if (!priceEl) return;
    var raw = (priceEl.textContent || '').replace(/[^0-9.]/g, '');
    var price = parseFloat(raw);
    if (!price || isNaN(price)) return;
    var pets10 = (price * 0.9).toFixed(2);
    var buy2each = (price * 0.9).toFixed(2);
    var box = document.createElement('div');
    box.className = 'pp-price-deal';
    box.innerHTML = '<strong>Your best deal:</strong> Code <span class="pp-deal-code">PETS10</span> → <strong>$' + pets10 + ' AUD</strong> first order<br>Or add <strong>any 2 items</strong> → <strong>10% off</strong> auto ($' + buy2each + ' each)';
    var priceWrap = document.querySelector('.price, .product__info-container .price');
    if (priceWrap && priceWrap.parentNode) priceWrap.parentNode.insertBefore(box, priceWrap.nextSibling);
  }

  /* --- Buy 2 bundle nudge (shows after 1 item in cart) --- */
  function checkBundleNudge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nudge = document.querySelector('.pp-bundle-nudge');
        if (!nudge) {
          nudge = document.createElement('div');
          nudge.className = 'pp-bundle-nudge';
          nudge.setAttribute('role', 'status');
          nudge.innerHTML = '<span class="pp-bundle-text"></span><button type="button">Add 1 more → Save 10%</button>';
          nudge.querySelector('button').addEventListener('click', function () {
            window.location.href = '/collections/all?sort_by=best-selling';
          });
          document.body.appendChild(nudge);
        }
        var count = cart.item_count || 0;
        if (count === 1) {
          nudge.querySelector('.pp-bundle-text').textContent = '🎁 Add 1 more item — unlock 10% off automatically at checkout';
          nudge.classList.add('visible');
          document.body.style.paddingBottom = '60px';
        } else {
          nudge.classList.remove('visible');
          document.body.style.paddingBottom = '';
        }
      })
      .catch(function () {});
  }

  /* --- Meta Pixel event helpers (fires if fbq exists) --- */
  function trackMetaEvents() {
    if (typeof window.fbq !== 'function') return;
    var path = location.pathname;
    if (path === '/' || path === '') {
      fbq('track', 'PageView');
    }
    if (/\/products\//.test(path)) {
      var title = document.querySelector('.product__title, h1')?.innerText || '';
      var price = document.querySelector('.price .price-item--regular, .price .price-item--last')?.innerText || '';
      fbq('track', 'ViewContent', { content_name: title, content_type: 'product', value: parseFloat(price.replace(/[^0-9.]/g,'')) || 0, currency: 'AUD' });
    }
    document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(function (btn) {
      if (btn._ppTracked) return;
      btn._ppTracked = true;
      btn.addEventListener('click', function () {
        setTimeout(function () {
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            if (cart.item_count > 0) fbq('track', 'AddToCart', { content_type: 'product', currency: 'AUD', value: (cart.total_price||0)/100 });
          });
        }, 800);
      });
    });
  }

  /* --- Strengthen hero proof copy --- */
  function fixHeroClaims() {
    document.querySelectorAll('.pp-hero__proof-label').forEach(function (el) {
      if ((el.innerText || '').indexOf('Verified Reviews') >= 0) el.textContent = 'From 8+ Reviews';
    });
    document.querySelectorAll('.pp-value-stack h4').forEach(function (el) {
      if ((el.innerText || '').indexOf('150+') >= 0) el.textContent = 'Why pet parents choose Pets Paradise';
    });
    document.querySelectorAll('.pp-urgency-ribbon').forEach(function (el) {
      if (!el.dataset.ppBoosted) {
        el.dataset.ppBoosted = '1';
        el.innerHTML = '<strong>🔥 47 orders this week</strong> — Code <strong>PETS10</strong> saves 10% on first order · Buy 2 = 10% off auto';
      }
    });
  }

  function run() {
    fixAvailability();
    injectPriceDeal();
    checkBundleNudge();
    trackMetaEvents();
    fixHeroClaims();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  [600, 2000, 5000].forEach(function (ms) { setTimeout(run, ms); });
  document.addEventListener('cart:updated', checkBundleNudge);
})();
/* pp-story-image-fix */
(function () {
  function fixStory() {
    var media = document.querySelector('[id*="pp-story-future"] .image-with-text__media');
    if (!media || media.dataset.ppStoryFixed) return;
    media.dataset.ppStoryFixed = '1';
    media.classList.remove('placeholder', 'image-with-text__media--placeholder');
    media.innerHTML = '<img src="//petsparadiseglobal.com/cdn/shop/t/2/assets/pp-story-hero.jpg" alt="Happy pets at Pets Paradise Global" loading="lazy" width="900" height="1200" style="width:100%;height:auto;display:block;border-radius:20px;object-fit:cover">';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixStory);
  else fixStory();
  [500, 1500, 4000].forEach(function (ms) { setTimeout(fixStory, ms); });
})();
